import { create } from "zustand";

interface SessionStore {
  isPopupOpened: boolean;
  setPopupOpened: (value: boolean) => void;
}

export const useSessionStore = create<SessionStore>((set) => ({
  isPopupOpened: sessionStorage.getItem("popupOpened") === "true",
  setPopupOpened: (value: boolean) => {
    sessionStorage.setItem("popupOpened", value.toString());
    set({ isPopupOpened: value });
  },
}));
